/**
 * Identidad visual de Prixia.
 *
 * Fuente única de los colores de marca. Antes vivían como literales sueltos en
 * la página "Por qué Prixia"; acá quedan disponibles para cualquier lugar que
 * los necesite en JS (gráficos, three.js, canvas) donde no llega Tailwind.
 *
 * Para estilar componentes usar las clases de Tailwind (`bg-prixia-ink`,
 * `text-prixia-gold`, …), que salen de estos mismos valores en
 * `tailwind.config.js`. No repetir hexes en el JSX.
 */

export interface BrandColor {
  hex: string;
  name: string;
  meaning: string;
}

export const PRIXIA_COLORS = {
  ink: { hex: '#1B3A5C', name: 'Azul Elefante', meaning: 'Confianza y profundidad' },
  blue: { hex: '#2A5A8C', name: 'Azul Medio', meaning: 'Tecnologia y claridad' },
  gold: { hex: '#D4A843', name: 'Dorado Premium', meaning: 'Valor y excelencia' },
  sky: { hex: '#6BAED6', name: 'Azul Cielo', meaning: 'Innovación y apertura' },
  silver: { hex: '#A8B5C4', name: 'Plata', meaning: 'Elegancia y sofisticación' },
} as const satisfies Record<string, BrandColor>;

export type BrandColorKey = keyof typeof PRIXIA_COLORS;

/** La paleta en orden de presentación, para la página de marca. */
export const BRAND_PALETTE: BrandColor[] = [
  PRIXIA_COLORS.ink,
  PRIXIA_COLORS.blue,
  PRIXIA_COLORS.gold,
  PRIXIA_COLORS.sky,
  PRIXIA_COLORS.silver,
];
